
import { MemberPermission } from './memberTypes';

/**
 * Update a permission in an array of permissions
 * If the permission being updated is "viewOnly", special logic is applied:
 * - If viewOnly is being checked, all other permissions are unchecked
 * - If any other permission is being checked, viewOnly is unchecked
 */
export const updatePermission = (
  permissions: MemberPermission[],
  permissionId: string,
  checked: boolean
): MemberPermission[] => {
  // Special handling for viewOnly permission
  if (permissionId === 'viewOnly' && checked) {
    // If viewOnly is being checked, uncheck all other permissions
    return permissions.map(p => ({
      ...p,
      checked: p.id === 'viewOnly'
    }));
  }
  
  // If any other permission is being checked, uncheck viewOnly
  if (permissionId !== 'viewOnly' && checked) {
    return permissions.map(p => ({
      ...p,
      checked: p.id === 'viewOnly' ? false : (p.id === permissionId ? checked : p.checked)
    }));
  }
  
  // Regular permission update
  return permissions.map(p => ({
    ...p,
    checked: p.id === permissionId ? checked : p.checked
  }));
};
